import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import {Match} from '../../models'
import template from './dota-results.jade'
import sources from '../../../helpers/sources'
import '../status'
import '../match-times'
import '../lineups'
import getState from '../../services/create-event'
import notify from '@scoutgg/ftw/source/services/notification'
import emitter from '@scoutgg/ftw/source/services/emitter'

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('edit-mode', Boolean)
export default class DotaResults extends HTMLElement {
  attached() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }

  reset() {
    this.state.reset()
  }

  matchChange() {
    this.update(this.match.load())
    this.state.listen(this, true)
  }

  saveStats() {
    var lineups = this.match.lineups.map(lineup => {
      return {
        _id: lineup._id,
        match: lineup.matchId,
        player: lineup.playerId,
        team: lineup.teamId,
        isBench: lineup.isBench,
        stats: lineup.stats,
        status: lineup.status,
        duration: lineup.duration,
      }
    })
    this.match.post('lineups', {lineups}).then(() => {
      notify('Stats saved', {level: 'success', timeout: 3000})
      this.state.reload(true)
      emitter.emit('match-updated')
      this.editMode = false
    })
  }

  canScrapeLineups(source) {
    var s = sources[source.source]
    return s && s.lineups
  }

  scrapeLineups(source) {
    source.post('scrape').then(() => {
      notify('Lineups gathered', {level: 'success', timeout: 5000})
      this.state.reload(true)
    }).catch((err) => {
      console.error(err.stack)
      notify(err.message, {level: 'danger', timeout: 10000})
    })
  }

  computeAggregate() {
    if(this.match.$isSubmitting) return
    this.match.post('aggregate')
      .then(() => {
        notify('Stats computed', {level: 'success', timeout: 5000})
      })
      .catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
      .then(() => this.render())
  }

  sendFeeds() {
    if(this.match.$isSubmitting) return
    this.match.post('send-feeds')
      .then(() => { notify('Events sent', {level: 'success', timeout: 5000}) })
      .catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
      .then(() => this.render())
    this.render()
  }

  toggleAuto() {
    if(this.match.$isSubmitting || this.match.stopFeeds) return
    this.match.post('confirm')
      .then(() => {
        notify('Feeds stopped', {level: 'success', timeout: 5000})
      })
      .catch((err) => {
        notify(err.message, {level: 'danger', timeout: 10000})
      })
      .then(() => this.render())
    this.render()
  }

  get state() {
    return getState(this.match)
  }
}
